export default __webpack_public_path__ + "static/media/close_icon.e0e689bd.svg";